module.exports = __webpack_public_path__ + "img/synopsis_003.07b28518.png";